export class PalletRequest{
    palletId?: number;
    constructor(palletId:number){
        this.palletId = palletId;
    }
}